import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import localeText from "../../../../../locale";

const MAX_DESCRIPTION = 200;

const StepCompanyRegistry = ({ data = {}, onSubmit, onBack, saving }) => {
  const [company_name, setCompanyName] = useState("");
  const [registered_office, setRegisteredOffice] = useState("");
  const [address, setAddress] = useState("");
  const [vat_number, setVatNumber] = useState("");
  const [ateco_code, setAtecoCode] = useState("");
  const [sector, setSector] = useState("");
  const [legal_representative, setLegalRepresentative] = useState({ name: "", phone: "" });
  const [administrative_representative, setAdministrativeRepresentative] = useState({
    name: "",
    phone: "",
  });
  const [website, setWebsite] = useState("");
  const [email, setEmail] = useState("");
  const [company_description, setCompanyDescription] = useState("");
  const [law_firm, setLawFirm] = useState({ name: "", phone: "" });
  const [accounting_firm, setAccountingFirm] = useState({ name: "", phone: "" });
  const [labor_consultant, setLaborConsultant] = useState({ name: "", phone: "" });

  useEffect(() => {
    setCompanyName(data.company_name ?? "");
    setRegisteredOffice(data.registered_office ?? "");
    setAddress(data.address ?? "");
    setVatNumber(data.vat_number ?? "");
    setAtecoCode(data.ateco_code ?? "");
    setSector(data.sector ?? "");
    setLegalRepresentative(data.legal_representative ?? { name: "", phone: "" });
    setAdministrativeRepresentative(data.administrative_representative ?? { name: "", phone: "" });
    setWebsite(data.website ?? "");
    setEmail(data.email ?? "");
    setCompanyDescription(data.company_description ?? "");
    setLawFirm(data.law_firm ?? { name: "", phone: "" });
    setAccountingFirm(data.accounting_firm ?? { name: "", phone: "" });
    setLaborConsultant(data.labor_consultant ?? { name: "", phone: "" });
  }, [data]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      company_name: company_name || null,
      registered_office: registered_office || null,
      address: address || null,
      vat_number: vat_number || null,
      ateco_code: ateco_code || null,
      sector: sector || null,
      legal_representative: {
        name: legal_representative.name || null,
        phone: legal_representative.phone || null,
      },
      administrative_representative: {
        name: administrative_representative.name || null,
        phone: administrative_representative.phone || null,
      },
      website: website || null,
      email: email || null,
      company_description: company_description
        ? company_description.slice(0, MAX_DESCRIPTION)
        : null,
      law_firm: { name: law_firm.name || null, phone: law_firm.phone || null },
      accounting_firm: { name: accounting_firm.name || null, phone: accounting_firm.phone || null },
      labor_consultant: {
        name: labor_consultant.name || null,
        phone: labor_consultant.phone || null,
      },
    });
  };

  const descLen = (company_description || "").length;

  return (
    <form onSubmit={handleSubmit} className="flex flex-column gap-3">
      <div>
        <h2 className="text-lg font-semibold m-0 mb-2" style={{ color: "var(--theme-text)" }}>
          {localeText("businessDiagnosisStep1Title") || "Anagrafica Azienda"}
        </h2>
        <p className="text-sm m-0 mb-2" style={{ color: "var(--theme-text-muted)" }}>
          {localeText("businessDiagnosisStep1Description") ||
            "Inserisci i dati generali della tua azienda per aiutarci a capire meglio la tua identità e il contesto in cui operi."}
        </p>
      </div>

      <div className="p-fluid grid">
        <div className="col-12 md:col-6">
          <label className="block text-sm mb-1" style={{ color: "var(--theme-text)" }}>
            {localeText("businessDiagnosisStep1LabelCompanyName") || "Ragione Sociale"}
            <span style={{ color: "var(--theme-primary)", marginLeft: 4 }}>*</span>
          </label>
          <InputText
            value={company_name}
            onChange={(e) => setCompanyName(e.target.value)}
            className="w-full border-round-md"
          />
        </div>
        <div className="col-12 md:col-6">
          <label className="block text-sm mb-1" style={{ color: "var(--theme-text)" }}>
            {localeText("businessDiagnosisStep1LabelRegisteredOffice") || "Sede Legale"}
            <span style={{ color: "var(--theme-primary)", marginLeft: 4 }}>*</span>
          </label>
          <InputText
            value={registered_office}
            onChange={(e) => setRegisteredOffice(e.target.value)}
            className="w-full border-round-md"
          />
        </div>
        <div className="col-12">
          <label className="block text-sm mb-1" style={{ color: "var(--theme-text)" }}>
            {localeText("businessDiagnosisStep1LabelAddress") || "Indirizzo"}
            <span style={{ color: "var(--theme-primary)", marginLeft: 4 }}>*</span>
          </label>
          <InputText
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            className="w-full border-round-md"
          />
        </div>
        <div className="col-12 md:col-6">
          <label className="block text-sm mb-1" style={{ color: "var(--theme-text)" }}>
            {localeText("businessDiagnosisStep1LabelVatNumber") || "P. IVA"}
            <span style={{ color: "var(--theme-primary)", marginLeft: 4 }}>*</span>
          </label>
          <InputText
            value={vat_number}
            onChange={(e) => setVatNumber(e.target.value)}
            className="w-full border-round-md"
          />
        </div>
        <div className="col-12 md:col-6">
          <label className="block text-sm mb-1" style={{ color: "var(--theme-text)" }}>
            {localeText("businessDiagnosisStep1LabelAtecoCode") || "Codice ATECO"}
            <span style={{ color: "var(--theme-primary)", marginLeft: 4 }}>*</span>
          </label>
          <InputText
            value={ateco_code}
            onChange={(e) => setAtecoCode(e.target.value)}
            className="w-full border-round-md"
          />
        </div>
        <div className="col-12">
          <label className="block text-sm mb-1" style={{ color: "var(--theme-text)" }}>
            {localeText("businessDiagnosisStep1LabelSector") || "Settore"}
            <span style={{ color: "var(--theme-primary)", marginLeft: 4 }}>*</span>
          </label>
          <InputText
            value={sector}
            onChange={(e) => setSector(e.target.value)}
            className="w-full border-round-md"
          />
        </div>
        <div className="col-12 md:col-6">
          <label className="block text-sm mb-1" style={{ color: "var(--theme-text)" }}>
            {localeText("businessDiagnosisStep1LabelLegalRepresentative") || "Rapp. Legale"}
            <span style={{ color: "var(--theme-primary)", marginLeft: 4 }}>*</span>
          </label>
          <InputText
            value={legal_representative.name}
            onChange={(e) => setLegalRepresentative((p) => ({ ...p, name: e.target.value }))}
            className="w-full border-round-md"
          />
        </div>
        <div className="col-12 md:col-6">
          <label className="block text-sm mb-1" style={{ color: "var(--theme-text)" }}>
            {localeText("businessDiagnosisStep1LabelPhone") || "Telefono"}
            <span style={{ color: "var(--theme-primary)", marginLeft: 4 }}>*</span>
          </label>
          <InputText
            value={legal_representative.phone}
            onChange={(e) => setLegalRepresentative((p) => ({ ...p, phone: e.target.value }))}
            className="w-full border-round-md"
          />
        </div>
        <div className="col-12 md:col-6">
          <label className="block text-sm mb-1" style={{ color: "var(--theme-text)" }}>
            {localeText("businessDiagnosisStep1LabelAdministrativeRepresentative") ||
              "Rapp. Amm.vo"}
            <span style={{ color: "var(--theme-primary)", marginLeft: 4 }}>*</span>
          </label>
          <InputText
            value={administrative_representative.name}
            onChange={(e) =>
              setAdministrativeRepresentative((p) => ({ ...p, name: e.target.value }))
            }
            className="w-full border-round-md"
          />
        </div>
        <div className="col-12 md:col-6">
          <label className="block text-sm mb-1" style={{ color: "var(--theme-text)" }}>
            {localeText("businessDiagnosisStep1LabelPhone") || "Telefono"}
            <span style={{ color: "var(--theme-primary)", marginLeft: 4 }}>*</span>
          </label>
          <InputText
            value={administrative_representative.phone}
            onChange={(e) =>
              setAdministrativeRepresentative((p) => ({ ...p, phone: e.target.value }))
            }
            className="w-full border-round-md"
          />
        </div>
        <div className="col-12 md:col-6">
          <label className="block text-sm font-medium mb-1" style={{ color: "var(--theme-text)" }}>
            {localeText("businessDiagnosisStep1LabelWebsite") || "Sito web"}
            <span style={{ color: "var(--theme-primary)", marginLeft: 4 }}>*</span>
          </label>
          <InputText
            value={website}
            onChange={(e) => setWebsite(e.target.value)}
            className="w-full border-round-md"
            placeholder={localeText("businessDiagnosisStep1PlaceholderWebsite") || "https://"}
          />
        </div>
        <div className="col-12 md:col-6">
            <label className="block text-sm mb-1" style={{ color: "var(--theme-text)" }}>
            {localeText("businessDiagnosisStep1LabelEmail") || "E-mail"}
            <span style={{ color: "var(--theme-primary)", marginLeft: 4 }}>*</span>
          </label>
          <InputText
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border-round-md"
          />
        </div>
        <div className="col-12">
          <label className="block text-sm mb-1" style={{ color: "var(--theme-text)" }}>
            {localeText("businessDiagnosisStep1LabelCompanyDescription") ||
              "Breve descrizione dell'azienda"}
          </label>
          <InputTextarea
            value={company_description}
            onChange={(e) => setCompanyDescription(e.target.value.slice(0, MAX_DESCRIPTION))}
            className="w-full border-round-md"
            rows={3}
            placeholder={
              localeText("businessDiagnosisStep1PlaceholderCompanyDescription") ||
              "Breve descrizione della mission e attività."
            }
          />
          <span className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
            {descLen}/{MAX_DESCRIPTION}
          </span>
        </div>
        <div className="col-12 md:col-6">
          <label className="block text-sm mb-1" style={{ color: "var(--theme-text)" }}>
            {localeText("businessDiagnosisStep1LabelLawFirm") || "Studio Legale"}
            <span style={{ color: "var(--theme-primary)", marginLeft: 4 }}>*</span>
          </label>
          <InputText
            value={law_firm.name}
            onChange={(e) => setLawFirm((p) => ({ ...p, name: e.target.value }))}
            className="w-full border-round-md"
          />
        </div>
        <div className="col-12 md:col-6">
          <label className="block text-sm mb-1" style={{ color: "var(--theme-text)" }}>
            {localeText("businessDiagnosisStep1LabelPhone") || "Telefono"}
            <span style={{ color: "var(--theme-primary)", marginLeft: 4 }}>*</span>
          </label>
          <InputText
            value={law_firm.phone}
            onChange={(e) => setLawFirm((p) => ({ ...p, phone: e.target.value }))}
            className="w-full border-round-md"
          />
        </div>
        <div className="col-12 md:col-6">
          <label className="block text-sm mb-1" style={{ color: "var(--theme-text)" }}>
            {localeText("businessDiagnosisStep1LabelAccountingFirm") || "Studio Comm.le"}
            <span style={{ color: "var(--theme-primary)", marginLeft: 4 }}>*</span>
          </label>
          <InputText
            value={accounting_firm.name}
            onChange={(e) => setAccountingFirm((p) => ({ ...p, name: e.target.value }))}
            className="w-full border-round-md"
          />
        </div>
        <div className="col-12 md:col-6">
          <label className="block text-sm mb-1" style={{ color: "var(--theme-text)" }}>
            {localeText("businessDiagnosisStep1LabelPhone") || "Telefono"}
            <span style={{ color: "var(--theme-primary)", marginLeft: 4 }}>*</span>
          </label>
          <InputText
            value={accounting_firm.phone}
            onChange={(e) => setAccountingFirm((p) => ({ ...p, phone: e.target.value }))}
            className="w-full border-round-md"
          />
        </div>
        <div className="col-12 md:col-6">
          <label className="block text-sm mb-1" style={{ color: "var(--theme-text)" }}>
            {localeText("businessDiagnosisStep1LabelLaborConsultant") || "Cons.te Lavoro"}
            <span style={{ color: "var(--theme-primary)", marginLeft: 4 }}>*</span>
          </label>
          <InputText
            value={labor_consultant.name}
            onChange={(e) => setLaborConsultant((p) => ({ ...p, name: e.target.value }))}
            className="w-full border-round-md"
          />
        </div>
        <div className="col-12 md:col-6">
          <label className="block text-sm mb-1" style={{ color: "var(--theme-text)" }}>
            {localeText("businessDiagnosisStep1LabelPhone") || "Telefono"}
            <span style={{ color: "var(--theme-primary)", marginLeft: 4 }}>*</span>
          </label>
          <InputText
            value={labor_consultant.phone}
            onChange={(e) => setLaborConsultant((p) => ({ ...p, phone: e.target.value }))}
            className="w-full border-round-md"
          />
        </div>
      </div>
      <div className="flex justify-content-end gap-2 flex-wrap mt-2">
        {onBack && (
          <Button
            type="button"
            label={localeText("back") || "Indietro"}
            className="p-button-text"
            onClick={onBack}
            disabled={saving}
          />
        )}
        <Button
          type="submit"
          disabled={saving}
          className="border-round-md flex align-items-center gap-2 py-3 px-3"
          onClick={handleSubmit}
        >
          <span className="text-sm text-white font-medium">{localeText("saveAndContinue")}</span>
          <i className="pi pi-arrow-right text-white text-xs"></i>
        </Button>
      </div>
    </form>
  );
};

export default StepCompanyRegistry;
